import React from "react";
import {
  getPreviewCardDummyDatabyCardID,
} from "../../../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import RenderSvg from "../../../../../../../../renderSvg/RenderSvg";
import "./cardPreview.css"
interface CardPreviewProps {
  kpi: any;
}
const CardPreview: React.FC<CardPreviewProps> = ({ kpi }) => {
  const userDataPoints = kpi?.data_points|| [];

  const dummyData = getPreviewCardDummyDatabyCardID(kpi.id);
  
  const cardTitle = kpi.title;
  const date = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const mainDataPoint = userDataPoints.length > 0 ? userDataPoints[0] : {};
  const footerDataPoints = userDataPoints.slice(1);

  return (
    <div className="preview-card-container">
      <div className="preview-card-header">
        <div className="preview-card-title">{cardTitle}</div>
        <div className="preview-card-date">PTD {date}</div>
      </div>
      {userDataPoints.length > 0 ? (
        <div className="preview-card-body">
          <div className="preview-card-main">
            <span className="preview-card-main-value">
              {dummyData[mainDataPoint.id] || "N/A"}
            </span>
            <span className="preview-card-main-percent">
              %
            </span>
          </div>
          <div className="preview-card-footer">
            {footerDataPoints.map((point: Record<string, any>,index:string) => (
              <div className="preview-card-footer-datapoint" key={point.id} >
                <div className="preview-card-footer-datapoint-value">{dummyData[point.id] || "N/A"}</div>
                <div className="preview-card-footer-datapoint-label">
                  {point.label} 
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="preview-card-body-with-not-datapoints">
          <RenderSvg name="MSLDistributionCardPreviewImage" />
        </div>
      )}
    </div>
  );
};

export default CardPreview;
